import React from "react";
import { Instagram, Facebook, Linkedin, Mail, Globe, MapPin } from "lucide-react";
import { FOOTER, ASSETS } from "@/data/content";

const SOCIAL_ICONS = { Instagram, Facebook, LinkedIn: Linkedin };

export const Footer = () => (
 <footer data-testid="footer" className="grain relative bg-ink text-cream">
 <div className="mx-auto max-w-[1400px] px-5 py-16 md:px-10 md:py-20">
 {/* Acknowledgement of Country */}
 <div className="rounded-xl border border-cream/15 bg-cream/[0.04] p-7 md:p-9">
 <div className="flex items-center gap-2 font-body text-xs uppercase tracking-[0.3em] text-ochre">
 <span className="inline-block h-2 w-6 rounded-full bg-terracotta" />
 Acknowledgement of Country
 </div>
 <div className="mt-5 grid gap-8 md:grid-cols-[1fr_auto] md:items-center md:gap-12">
 <p className="max-w-3xl font-display text-base leading-relaxed text-cream/90 md:text-lg">
 {FOOTER.acknowledgement}
 </p>
 <figure className="flex flex-col items-center">
 <img src={ASSETS.wcUncleLewis} alt="Uncle Lewis Walker" className="h-72 w-auto object-contain drop-shadow-[0_16px_24px_rgba(0,0,0,0.35)] md:h-80" />
 <figcaption className="mt-2 font-script text-xl text-ochre">Uncle Lewis Walker</figcaption>
 </figure>
 </div>
 </div>

 <div className="mt-14 grid gap-12 md:grid-cols-[1.4fr_1fr_1fr]">
 <div>
 <div className="flex items-center gap-5">
 <div className="h-28 w-28 shrink-0 overflow-hidden"><img src={ASSETS.nradLogo} alt="NRAD Almanac 2026–2027" className="h-full w-full object-cover" /></div>
 <div>
 <div className="font-display text-2xl font-semibold">NRAD, The Almanac</div>
 <div className="font-body text-sm text-cream/60">The National Record & People's Almanac</div>
 </div>
 </div>
 <p className="mt-6 max-w-md font-body text-sm leading-relaxed text-cream/70">
 A shared record of Australia's regenerative agriculture movement, 2026–2027, a Carbon8 project.
 Founded by Mike, Helen &amp; Kelly. Edited by Kylie Woodham.
 </p>
 <div className="mt-6 flex items-center gap-4">
 <div className="h-20 w-20 overflow-hidden"><img src={ASSETS.vrgBadge} alt="Verified RegenGrown" className="h-full w-full object-cover" title="Verified RegenGrown" /></div>
 <div className="h-20 w-20 overflow-hidden"><img src={ASSETS.carbon8Round} alt="Carbon8" className="h-full w-full object-cover" title="Carbon8" /></div>
 </div>
 </div>

 <div>
 <h4 className="font-body text-xs uppercase tracking-[0.28em] text-cream/50">Explore</h4>
 <ul className="mt-5 space-y-3 font-body text-sm">
 {[
 { l: "The Vision", h: "#vision" },
 { l: "Inside the 2026 Edition", h: "#edition" },
 { l: "Featured Voices", h: "#voices" },
 { l: "The People's Almanac", h: "#almanac" },
 { l: "Reserve Your Page", h: "#reserve" },
 ].map((x) => (
 <li key={x.h}>
 <a href={x.h} data-testid={`footer-link-${x.h.slice(1)}`} className="text-cream/75 transition-colors hover:text-ochre">
 {x.l}
 </a>
 </li>
 ))}
 </ul>
 </div>

 <div>
 <h4 className="font-body text-xs uppercase tracking-[0.28em] text-cream/50">Get in touch</h4>
 <ul className="mt-5 space-y-3 font-body text-sm text-cream/75">
 <li className="flex items-center gap-2">
 <Mail size={15} className="text-ochre" />
 <a href={`mailto:${FOOTER.email}`} data-testid="footer-email" className="transition-colors hover:text-ochre">{FOOTER.email}</a>
 </li>
 <li className="flex items-center gap-2"><Globe size={15} className="text-ochre" />{FOOTER.domain}</li>
 <li className="flex items-start gap-2"><MapPin size={15} className="mt-0.5 text-ochre" />{FOOTER.address}</li>
 </ul>
 <div className="mt-6 flex gap-3">
 {FOOTER.socials.map((s) => {
 const Icon = SOCIAL_ICONS[s];
 return (
 <a
 key={s}
 href="#top"
 aria-label={s}
 data-testid={`footer-social-${s.toLowerCase()}`}
 className="inline-flex h-10 w-10 items-center justify-center rounded-full border border-cream/20 text-cream/70 transition-all hover:border-ochre hover:text-ochre"
 >
 <Icon size={17} />
 </a>
 );
 })}
 </div>
 </div>
 </div>

 <div className="mt-14 flex flex-col items-center justify-between gap-3 border-t border-cream/15 pt-7 font-body text-xs text-cream/50 md:flex-row">
 <span>© {new Date().getFullYear()} Carbon8. NRAD Almanac. All rights reserved.</span>
 <span className="font-script text-lg text-cream/70">put down in ink · returned to the soil</span>
 </div>
 </div>
 </footer>
);
